import { useState, useCallback } from 'react';
import { cmsAPI } from '../../../core/api/api';

const mensajeError = (err, fallback) =>
  err?.response?.data?.message || fallback;

export const useCms = () => {
  const [contenidos, setContenidos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const buscar = useCallback(async (filtros = {}) => {
    setLoading(true);
    setError(null);
    try {
      const res = await cmsAPI.getContenidos(filtros);
      setContenidos(res.data || []);
    } catch (err) {
      const msg = mensajeError(err, 'No se pudieron cargar los contenidos.');
      setError(msg);
      throw new Error(msg);
    } finally {
      setLoading(false);
    }
  }, []);

  const guardar = useCallback(async (data) => {
    setLoading(true);
    try {
      const res = await cmsAPI.guardar(data);
      return res.data;
    } catch (err) {
      throw new Error(mensajeError(err, 'No se pudo guardar el contenido.'));
    } finally {
      setLoading(false);
    }
  }, []);

  const actualizar = useCallback(async (id, data) => {
    setLoading(true);
    try {
      const res = await cmsAPI.actualizar(id, data);
      return res.data;
    } catch (err) {
      throw new Error(mensajeError(err, 'No se pudo actualizar el contenido.'));
    } finally {
      setLoading(false);
    }
  }, []);

  const eliminar = useCallback(async (id) => {
    setLoading(true);
    try {
      await cmsAPI.eliminar(id);
    } catch (err) {
      throw new Error(mensajeError(err, 'No se pudo eliminar el contenido.'));
    } finally {
      setLoading(false);
    }
  }, []);

  const subirMedia = useCallback(async (file) => {
    setLoading(true);
    try {
      const res = await cmsAPI.subirMedia(file);
      return res.data?.url;
    } catch (err) {
      throw new Error(mensajeError(err, 'No se pudo subir el archivo.'));
    } finally {
      setLoading(false);
    }
  }, []);

  return { contenidos, loading, error, buscar, guardar, actualizar, eliminar, subirMedia };
};
